/* eslint-disable */
<template>
    <div class="container-fluid no-fluid trading-view">
        <!-- Modal search stock -->
        <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="addToWatchlistLabel" aria-hidden="true"
            :class="{ 'show': searchStockModalShow, 'd-block': searchStockModalActive }">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="addToWatchlistLabel">{{
                            getSearchModalLabel }}</h5>
                    </div>
                    <div class="modal-body">
                        <StockSearch />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal"
                            @click="searchStockModalActive = false; searchStockModalShow = false;">{{
                            getCloseLabel
                            }}</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="searchStockModalActive" class="modal-backdrop fade show">
        </div>
        <!-- Modal placed order -->
        <div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true"
            :class="{ 'show': orderPlacedModalShow, 'd-block': orderPlacedModalActive }">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header order-placed-modal-header">
                        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"
                            @click="orderPlacedModalActive = false; orderPlacedModalShow = false;"></button>
                    </div>
                    <div class="modal-body">
                        <OrderPlaced :order="orderModel" />
                    </div>
                </div>
            </div>
        </div>
        <div v-if="orderPlacedModalActive" class="modal-backdrop fade show">
        </div>
        <!-- Modal Trade at Close info -->
        <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="tradeAtCloseInfoLabel"
            aria-hidden="true" :class="{ 'show': tradeAtCloseInfoModalShow, 'd-block': tradeAtCloseInfoModalActive }">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="tradeAtCloseInfoLabel">{{ getTradeAtCloseLabel }}</h5>
                        <button type="button" class="btn-close" aria-label="Close"
                            @click="closeTradeAtCloseInfoModal"></button>
                    </div>
                    <div class="modal-body trade-at-close-info-body">
                        <p v-for="paragraph in getTradeAtCloseInfoParagraphs" :key="paragraph">
                            {{ paragraph }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="tradeAtCloseInfoModalActive" class="modal-backdrop fade show"></div>
        <!-- Modal market order illiquidity warning -->
        <div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true"
            :class="{ 'show': marketOrderWarningModalShow, 'd-block': marketOrderWarningModalActive }">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="btn-close" aria-label="Close"
                            @click="closeMarketOrderWarningModal"></button>
                    </div>
                    <div class="modal-body">
                        {{ marketOrderWarningMessage }}
                    </div>
                    <div class="modal-footer market-order-warning-footer">
                        <button v-if="marketOrderWarningCanContinue" type="button" class="btn btn-secondary"
                            @click="closeMarketOrderWarningModal">{{ getCancelLabel }}</button>
                        <button v-if="marketOrderWarningCanContinue" type="button" class="btn btn-primary"
                            @click="continueMarketOrderAfterWarning">{{ getContinueLabel }}</button>
                        <button v-else type="button" class="btn btn-primary"
                            @click="closeMarketOrderWarningModal">{{ getCloseLabel }}</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="marketOrderWarningModalActive" class="modal-backdrop fade show"></div>
        <div class="row sm-gutters align-trade-buttons">
            <div class="col-sm-12 col-md-12">
                <div class="row">
                    <div class="btn-group d-flex mtb15" role="group">
                        <input type="radio" class="btn-check" id="otsell" value="S" v-model="orderAction"
                            autocomplete="off">
                        <label class="btn" :class="{ 'btn-sell': 'S' === orderAction }" for="otsell">{{
                            getSellLabel.toUpperCase() }}</label>
                        <input type="radio" class="btn-check" id="otbuy" autocomplete="off" value="B"
                            v-model="orderAction">
                        <label class="btn" :class="{'btn-buy' : 'B' === orderAction }" for="otbuy">{{
                            getBuyLabel.toUpperCase() }}</label>
                    </div>
                </div>
                <div class="row mt5">
                    <div class="col-md-12">
                        <label for="selectMarketOption">{{ getOrderTypeLabel }}</label>
                        <select id="selectMarketOption" class="form-select" v-model="orderType">
                            <option value="put_market_order_ex">{{ getMarketOption }}</option>
                            <option value="put_limit_order_ex">{{ getLimitOption }}</option>
                            <option value="put_stop_limit_order">{{ getStopLimitOption }}</option>
                            <option value="put_stop_market_order">{{ getStopMarketOption }}</option>
                            <option v-if="getSelectedItemExchangeCode.localeCompare('XFRA') !== 0 && getSelectedTradingCodeShareTypeId !== 2" 
                                value="put_iceberg_order">
                                {{ getIcebergOption }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="row mt15">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-sm-4">
                                <label for="tradeStockCode">{{ getCodeLabel }}</label>
                                <input id="tradeStockCode" type="text" class="form-control"
                                    v-model="getSelectedItemCode" disabled />
                            </div>
                            <div class="col-sm-4">
                                <label for="tradeStockExchangeCode">{{ getExchangeLabel }}</label>
                                <input id="tradeStockExchangeCode" type="text" class="form-control"
                                    v-model="getSelectedItemExchangeCode" disabled />
                            </div>
                            <div class="col-sm-4">
                                <label for="tradeStockSegmentCode">{{ getSegmentLabel }}</label>
                                <input id="tradeStockSegmentCode" type="text" class="form-control"
                                    v-model="getSelectedItemSegment" disabled />
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 mt15">
                        <label for="tradeStockName">{{ getNameLabel }}</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="inputGroup-sizing-sm">
                                    <i class="icon ion-md-search"></i>
                                </span>
                            </div>
                            <input id="tradeStockName" type="text" class="form-control" :placeholder="getCodePlaceholder"
                                @focus="showSearchModal" v-model="getStockName" />
                        </div>
                    </div>
                </div>
                <div class="row mt15">
                    <div class="col-md-12 trading-dynamic-range-label">
                        {{ getDynamicRangeLabel }}
                    </div>
                    <div class="table-responsive">
                        <table class="table table-sm trading-dynamic-range-table">
                            <thead>
                                <tr class="text-center">
                                    <th scope="col" v-if="2 !== getSelectedTradingCodeShareTypeId">{{
                                        getMinPriceLabel }}</th>
                                    <th scope="col" v-if="2 !== getSelectedTradingCodeShareTypeId">{{
                                        getMaxPriceLabel }}</th>
                                    <th scope="col">{{ getTickSizeLabel }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="text-center">
                                    <td v-if="2 !== getSelectedTradingCodeShareTypeId"><strong>{{
                                        formatPrice(getQuoteTrading.minp || 0, getStockCurrency()).replace(' ', '&nbsp;') }}
                                    </strong>
                                    </td>
                                    <td v-if="2 !== getSelectedTradingCodeShareTypeId"><strong>{{
                                        formatPrice(getQuoteTrading.maxp || 0, getStockCurrency()).replace(' ', '&nbsp;') }}
                                    </strong>
                                    </td>
                                    <td><strong>{{ parseNumber(calculateTickSize, 10).replace(/\.?0+$/, "") }}</strong></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row mt15 text-center">
                    <div class="col-md-2">
                        <button class="btn btn-primary trading-quantity-button" @click="decreaseOrderStockCount"
                            :disabled="isQuantityDecreaseDisabled">-</button>
                    </div>
                    <div class="col-md-8">
                        <div class="row">
                            <div class="col-md-12">
                                <input style="text-align: center;" id="tradeStockcount" type="text" inputmode="numeric"
                                    class="form-control" v-model.number="orderStockCount"
                                    @keypress="onlyForCurrencyOrderStockCount"
                                    :disabled="(0 === getAvailableStocks && 'S' === orderAction) || 0 === getStockName?.length"
                                    :placeholder="2 !== getSelectedTradingCodeShareTypeId ? getNumberOfSharesLabel : getFaceValueLabel" />
                            </div>
                        </div>
                        <div class="row text-center trading-owned-quantity-row">
                            <div class="col-md-12">
                                <span v-if="hasSelectedPosition">
                                    {{ getYouOwnLabel }} <strong>{{ formatOwnedQuantity }}</strong>
                                    @ {{ getAveragePriceShortLabel }} <strong>{{ formatAveragePositionPrice.replace(' ', '&nbsp;') }}</strong>
                                </span>
                                <span v-else>
                                    {{ getYouHaveLabel }} <strong>{{ formatOwnedQuantity }}</strong>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <button class="btn btn-primary trading-quantity-button" @click="increaseOrderStockCount"
                            :disabled="isQuantityIncreaseDisabled">+</button>
                    </div>
                    <div v-if="isMarketOrder" class="col-md-12 trading-order-hint trading-helper-box">
                        {{ getMarketOrderHintLabel }}
                    </div>
                </div>
                <div v-if="orderType === 'put_market_order_ex' || orderType === 'put_limit_order_ex'">
                    <div class="col-md-12 trade-at-close-row">
                        <input id="orderTradeAtClose" class="trade-at-close-checkbox" type="checkbox" v-model="tradeAtClose" />
                        <label for="orderTradeAtClose">{{ getTradeAtCloseLabel }}</label>
                        <button type="button" class="trade-at-close-info-button"
                            :aria-label="getTradeAtCloseLabel" @click="openTradeAtCloseInfoModal">i</button>
                    </div>
                </div>
                <div v-if="orderType.toUpperCase().includes('MARKET') && isStopOrder" class="row mt15">
                    <div class="col-md-12">
                        <div class="trading-extra-price-field">
                            <label for="stopOrderPrice">{{ getStopPriceLabel }}</label>
                            <input id="stopOrderPrice" type="number" min="0.00" class="form-control trading-price-number-input" step="0.01"
                                v-model="orderStopPrice" />
                            <div class="trading-limit-order-hint trading-helper-box">
                                {{ getStopOrderHintLabel }}
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="!isMarketOrder" class="row">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-12">
                                <label v-if="2 !== getSelectedTradingCodeShareTypeId" for="limitOrderPrice">{{ getPriceLabel }}</label>
                                <label v-else for="limitOrderPrice">{{ getPriceLabel }} (%)</label>
                                <input id="limitOrderPrice" type="number" min="0.00" class="form-control trading-price-number-input" step="0.01"
                                    v-model="limitOrderPrice" @keypress="onlyForCurrencyLimitedOrderPrice"
                                    @focusin="limitPriceFocusGained()" @focusout="limitPriceFocusLost()" />
                            </div>
                        </div>
                        <div v-if="isLimitOrder || isIcebergOrder" class="col-md-12 trading-limit-order-hint trading-helper-box">
                            {{ getLimitOrderHintLabel }}
                        </div>
                        <div v-if="isStopOrder" class="trading-extra-price-field">
                            <label for="stopOrderPrice">{{ getStopPriceLabel }}</label>
                            <input id="stopOrderPrice" type="number" min="0.00" class="form-control trading-price-number-input" step="0.01"
                                v-model="orderStopPrice" />
                            <div class="trading-limit-order-hint trading-helper-box">
                                {{ getStopOrderHintLabel }}
                            </div>
                        </div>
                        <div v-if="isIcebergOrder" class="trading-extra-price-field">
                            <label for="orderPeakValue">{{ getPeakLabel }}</label>
                            <input id="orderPeakValue" type="number" min="0.00" class="form-control trading-price-number-input" step="0.01"
                                v-model="orderPeakValue" />
                            <div class="trading-limit-order-hint trading-helper-box">
                                {{ getIcebergPeakHintLabel }}
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Modal date select -->
                <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="datePickerModalLabel"
                    aria-hidden="true" :class="{ 'show': dateSelectionModalShow, 'd-block': dateSelectionModalActive }">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="datePickerModalLabel">{{ getChoseExpiryDateLabel }}</h5>
                            </div>
                            <div class="modal-body">
                                <Datepicker v-model="orderSelectedDate" format="yyyy-MM-dd" placeholder="yyyy-mm-dd"
                                    :minDate="new Date()" showNowButton>
                                </Datepicker>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal"
                                    @click="dateSelectionModalActive = false; dateSelectionModalShow = false;">{{
                                    getCloseLabel
                                    }}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="dateSelectionModalActive" class="modal-backdrop fade show"></div>
                <div class="trading-actions-group">
                    <div class="row mt15 trading-estimated-total-row">
                        <div class="col-md-12">
                            {{ getEstimatedTotalLabel }}:
                            <strong>{{ formatPrice(getEstimatedTotalAsMoney(), getStockCurrency(false), 2).replace(' ', '&nbsp;') }}</strong>
                        </div>
                    </div>
                    <div class="row trading-available-invest-row">
                        <div class="col-md-12">
                            {{ getExcessFundsLabel }}:
                            <strong>{{ formatPrice(getAvailableToInvest, getCurrency, 2).replace(' ', '&nbsp;') }}</strong>
                        </div>
                    </div>
                    <div class="row mt15">
                        <div class="col-md-12">
                            <label for="selectValidity">{{ getValidityLabel }}</label>
                            <select id="selectValidity" class="form-select" v-model="orderValidity"
                                :disabled="0 === getStockName?.length">
                                <option value="1">{{ getDailyLabel }}</option>
                                <option value="3">{{ getGoodTillCancelledLabel }}</option>
                                <option value="2">{{ getChoseDateLabel }}</option>
                                <option v-if="showEoc" value="4">IOC (Immediate-or-Cancel)</option>
                                <option v-if="showFok" value="5">FOK (Fill-or-Kill)</option>
                                <option v-if="showBoc" value="6">BOC (Book-or-Cancel)</option>
                            </select>
                        </div>
                    </div>
                    <div class="row mt15">
                        <div class="col-md-12">
                            <label for="selectRestriction">{{ getRestrictionsLabel }}</label>
                            <select id="selectRestriction" class="form-select" v-model="orderRestriction"
                                :disabled="0 === getStockName?.length">
                                <option value="">{{ getNoRestrictionsLabel }}</option>
                                <option value="OA">OA (Opening Auction)</option>
                                <option value="AU">AU (Auction-only)</option>
                                <option value="CA">CA (Closing Auction)</option>
                                <option value="EA">EA (End-of-day Auction-only)</option>
                                <option value="MT">MT (Main Trading Phase)</option>
                                <option value="MA">MA (Main Trading Auctions)</option>
                            </select>
                        </div>
                    </div>
                    <div class="row trading-actions-row"
                        :class="{ 'align-trade-button-market': 'put_market_order_ex' === orderType, 'align-trade-button-limit': 'put_market_order_ex' !== orderType }">
                        <div class="col">
                            <input type="submit" class="btn btn-primary w-100" :value="getSubmitLabel"
                                :disabled="canSubmitOrder" @click.prevent="submitOrder" />
                        </div>
                        <div class="col">
                            <input type="button" class="btn btn-outline-primary w-100" :value="getClearLabel"
                                :disabled="!canClearTradeForm" @click.prevent="clearTradeForm" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import http from "@/api/http-common";
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import UiUtils from "@/assets/js/ui_utils.js";
import ApiUtils from "@/assets/js/api_utils.js";
import HttpUtils from "@/assets/js/http_utils.js";
import I18n from "@/lang/i18n.js";
import StockSearch from "@/features/dashboard/components/StockSearch.vue";
import OrderPlaced from "@/features/trading/components/OrderPlaced.vue";
import { getPortfolioSummary } from "@/features/wallet/wallet-portfolio-metrics";

// exchange liquidity price levels
const sdLiqPriceLevels = [0, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000, 20000, 50000];
// exchange tick sizes for limit prices
const sdMaxTickSizes = [500, 500, 200, 100, 50, 20, 10, 5, 2, 1, 0.5];

export default {
    components: {
        Datepicker,
        StockSearch,
        OrderPlaced
    },
    props: {
        stockCode: {
            required: false,
            type: String,
            default: null
        },
        requestedQuantity: {
            required: false,
            type: Number,
            default: 0
        },
        requestedPrice: {
            required: false,
            type: Number,
            default: 0
        },
        requestedAction: {
            required: false,
            type: String,
            default: null
        },
        preserveSelectedInstrument: {
            required: false,
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            /* operation type, B(uy) or S(ell) */
            orderAction: this.requestedAction 
                ? this.requestedAction 
                : "B", 
            /* market or limit order as request action */
            orderType: "put_market_order_ex", 
            /* required stocks count */
            orderStockCount: this.requestedQuantity 
                ? this.requestedQuantity 
                : null,
            /* expected minimum price */
            orderMinExpectedPrice: 0,
            /* expected maximum price */ 
            orderMaxExpectedPrice: 0,
            /* order validity code */ 
            orderValidity: 1, 
            /* order trade-at-close code */
            tradeAtClose: true,
            /* order market restriction */
            orderRestriction: "",
            /* order stop price for stop orders */
            orderStopPrice: 0,
            /* iceberg order peak value */
            orderPeakValue: 0,
            /* user required price for limit orders */
            limitOrderPrice: 0 !== this.requestedPrice 
                ? this.requestedPrice 
                : 0, 
            /* user selected order expiry date */
            orderSelectedDate: null,
            /* active modal dialog for date selection */
            dateSelectionModalActive: false, 
            /* show modal dialog for date selection */
            dateSelectionModalShow: false,
            /* active modal dialog for stock search */
            searchStockModalActive: false,
            /* show modal dialog for stock search */
            searchStockModalShow: false,  
            orderPlacedModalActive: false,
            orderPlacedModalShow: false,
            tradeAtCloseInfoModalActive: false,
            tradeAtCloseInfoModalShow: false,
            marketOrderWarningModalActive: false,
            marketOrderWarningModalShow: false,
            marketOrderWarningMessage: "",
            marketOrderWarningCanContinue: false,
            marketOrderWarningAcceptedKey: null,
            orderModel: {},
            showEoc: false,
            showBoc: false,
            showFok: false
/*            showEoc: this.getShowIocValue,
            showBoc: this.getShowBocValue,
            showFok: this.getShowFokValue*/
        }
    },
    watch: {
        orderValidity: function (newVal, oldVal) {
            if (parseInt(newVal) !== parseInt(oldVal) && 2 === parseInt(newVal)) {
                // open modal
                const body = document.querySelector("body");
                this.dateSelectionModalActive = true;
                this.dateSelectionModalShow = true;
                body.classList.add("modal-open");
            }
        },
        getSelectedTradingAction: function (newVal, oldVal) {
            if (oldVal !== newVal) {
                this.orderAction = newVal;
            }
        },
        orderAction: function (newVal) {
            if ("S" === newVal) {
                this.clampSellQuantity();
            }
        },
        getSelectedItemCode: function (newVal, oldVal) {
            if (oldVal != newVal) {
                if (this.$store.getters["getSuppressSelectedTradingQuoteSync"]) {
                    return;
                }
                // get exchange code
                const exchanges = this.$store.getters["getExchanges"];
                const itemExchangeCode = UiUtils.getExchangeCodeById(exchanges, this.$store.getters["getSelectedTradingExchangeId"]);                
                (async () => await ApiUtils.setQuoteTrading(http, UiUtils, this.$store, itemExchangeCode, newVal))();
                (async () => await this.getDepth())();
                // if modal search is open, close it
                this.searchStockModalActive = false; 
                this.searchStockModalShow = false;
                this.showEoc = this.getShowIocValue;
                this.showBoc = this.getShowBocValue;
                this.showFok = this.getShowFokValue;               
            }
        },
        orderStockCount: function (newVal, oldVal) {
            if ("S" === this.orderAction && parseFloat(newVal || 0) > this.getAvailableStocks) {
                this.orderStockCount = this.getAvailableStocks;
                return;
            }

            if (parseInt(newVal) !== parseInt(oldVal)) {
                if (this.getQuoteTrading.minp) {
                    this.orderMinExpectedPrice = (this.getQuoteTrading?.minp * newVal);
                    this.orderMaxExpectedPrice = (this.getQuoteTrading?.maxp * newVal);
                }
                this.marketOrderWarningAcceptedKey = null;
            }
        },
        getOrderToEdit: function (newVal) {
            if (newVal) {                
                this.orderAction = newVal.action;
                this.orderType = this.getOrderCommandByOrderType(newVal.type);
                this.$store.commit("setSelectedTradingExchangeId",
                    UiUtils.getExchangeIdByCode(this.$store.getters["getExchanges"], newVal.xcode));
                this.$store.commit("setSelectedTradingCode", newVal.code);
                this.$store.commit("setSelectedTradingCodeSegment", newVal.sgm);
                this.$store.commit("setSelectedTradingCodeShareTypeId", parseInt(newVal.stid ?? newVal.tID));
                this.$store.commit("setOrderIdToUpdate", newVal.order_id);
                this.$store.commit("setSelectedTradingStockName",
                    0 === 'BG'.localeCompare(this.getUserLanguage())
                        ? newVal.nBG
                            ? newVal.nBG
                            : newVal.nEN
                        : newVal.nEN);
                this.orderStockCount = newVal.amount;
                this.limitOrderPrice = newVal.type.toUpperCase().includes("MARKET")
                    ? 0
                    : newVal.price;
                this.orderStopPrice = newVal.stop;
                this.orderPeakValue = newVal.peak;
                this.tradeAtClose = typeof newVal.tac === "undefined" ? true : newVal.tac;
                this.showEoc = this.getShowIocValue;
                this.showBoc = this.getShowBocValue;
                this.showFok = this.getShowFokValue;                  
            }
        },
        orderType: function (newVal) {
            // by exchange
            if (this.getSelectedItemExchangeCode.toLowerCase().localeCompare('xfra') === 0) {
                this.showBoc = false;
                this.showEoc = false;
                this.showFok = false;
            } 
            // by order validity
            else if (newVal.localeCompare("put_stop_market_order") === 0) {
                this.showBoc = false;
                this.showEoc = false;
                this.showFok = false;
            } else if (newVal.localeCompare("put_stop_limit_order") === 0) {
                this.showBoc = false;
                this.showEoc = false;
                this.showFok = false;
            } else if (newVal.localeCompare("put_iceberg_order") === 0) {
                this.showBoc = false;
                this.showEoc = false;
                this.showFok = false;
            } else if (newVal.localeCompare("put_market_order_ex") === 0) {
                this.showBoc = false;
                this.showEoc = true;
                this.showFok = true;
            }  else {
                this.showBoc = true;
                this.showEoc = true;
                this.showFok = true;
            }
            this.marketOrderWarningAcceptedKey = null;
        }
    },
    methods: {
        t(key, ...args) {
            const language = typeof this.getUserLanguage === "function" ? this.getUserLanguage() : this.getUserLanguage;
            return I18n.t(key, language, ...args);
        },
        formatPrice(val, curr, autoDigits) {
            return UiUtils.formatPrice(val, curr, this.getUserLanguage(), autoDigits);
        },
        calculateNumberOfMeaningfulDigits(val) {
            return UiUtils.calculateNumberOfMeaningfulDigits(val);
        },
        getUserType() {
            return this.$store.getters["getUserType"];
        },
        getOrderCommandByOrderType(orderType) {
            if (orderType.toUpperCase().localeCompare("STOP-MARKET") === 0) {
                return "put_stop_market_order";
            }
            if (orderType.toUpperCase().localeCompare("STOP-LIMIT") === 0) {
                return "put_stop_limit_order";
            }
            if (orderType.toUpperCase().localeCompare("MARKET") === 0) {
                return "put_market_order_ex";
            }
            if (orderType.toUpperCase().localeCompare("ICEBERG") === 0) {
                return "put_iceberg_order";
            }
            return "put_limit_order_ex";
        },
        increaseOrderStockCount() {
            if (this.isQuantityIncreaseDisabled) {
                return;
            }

            if (2 != this.getSelectedTradingCodeShareTypeId) {
                this.orderStockCount++;
            } else {
                this.orderStockCount += this.getBondFaceValueStep();
            }
        },
        decreaseOrderStockCount() {         
            if (this.isQuantityDecreaseDisabled) {
                return;
            }

            if (0 < this.orderStockCount) {
                if (2 != this.getSelectedTradingCodeShareTypeId) {
                    this.orderStockCount--;
                } else {
                    this.orderStockCount = Math.max(0, this.orderStockCount - this.getBondFaceValueStep());
                }   
            }
        },
        clampSellQuantity() {
            if ("S" === this.orderAction && parseFloat(this.orderStockCount || 0) > this.getAvailableStocks) {
                this.orderStockCount = this.getAvailableStocks;
            }
        },
        getExpirationDateByOrderValidity() {
            const nowDate = new Date();
            const prevDate = new Date(nowDate.getTime());            
            switch (parseInt(this.orderValidity)) {
                case 1:
                case 4:
                case 5:
                case 6: {
                    return nowDate.toISOString().slice(0, 10);
                }
                case 2: {
                    return new Date(this.orderSelectedDate).toISOString().slice(0, 10);
                }
                case 3: {
                    prevDate.setDate(nowDate.getDate() + 360);
                    return prevDate.toISOString().slice(0, 10);
                }
            }

            return nowDate.toISOString().slice(0, 10);
        },
        getDate(unix) {
            return UiUtils.parseUnixTime(unix);
        },
        getBondEstimatedAmount(price) {
            return UiUtils.getBondMoneyValue(
                this.getSelectedTradingStock(),
                this.orderStockCount,
                price,
                this.getSelectedTradingStock()
            );
        },
        getBondFaceValueStep() {
            const stock = this.getSelectedTradingStock();
            return UiUtils.getBondFaceValueStep(
                stock,
                this.getSelectedItemExchangeCode,
                stock
            );
        },
        parsePositiveNumber(value) {
            const parsed = parseFloat(value);
            return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
        },
        getMarketOrderPayloadKey() {
            return [
                this.getSelectedItemExchangeCode,
                this.getSelectedItemCode,
                this.orderAction,
                this.orderType,
                this.orderStockCount,
                this.orderValidity,
                this.orderRestriction,
                this.tradeAtClose
            ].join("|");
        },
        getMarketOrderPricingDecision(fee = 0) {
            const quoteTrading = this.getQuoteTrading;
            const depth = this.getStoredDepth;
            const isBuy = this.orderAction.toUpperCase().localeCompare('B') === 0;
            const quotePrice = isBuy
                ? this.parsePositiveNumber(quoteTrading.a)
                : this.parsePositiveNumber(quoteTrading.b);
            const lastDealPrice = this.parsePositiveNumber(quoteTrading.ltp)
                || this.parsePositiveNumber(quoteTrading.ldp)
                || this.parsePositiveNumber(depth.ldp);
            const closePrice = this.parsePositiveNumber(quoteTrading.clp)
                || this.parsePositiveNumber(quoteTrading.prc)
                || this.parsePositiveNumber(depth.clp)
                || this.parsePositiveNumber(depth.prc);
            let price = 0;
            let source = "none";

            if (quotePrice > 0) {
                price = quotePrice;
                source = "quote";
            } else if (lastDealPrice > 0) {
                price = lastDealPrice;
                source = "lastDeal";
            } else if (closePrice > 0) {
                price = closePrice;
                source = "close";
            }

            const estimatedTotal = 2 === this.getSelectedTradingCodeShareTypeId
                ? this.getBondEstimatedAmount(price)
                : price * parseFloat(this.orderStockCount || 0);
            const parsedFee = parseFloat(fee || 0);
            const guaranteeDeposit = isBuy && source === "quote"
                ? estimatedTotal * 1.02 + parsedFee
                : isBuy && (source === "lastDeal" || source === "close")
                    ? estimatedTotal * 4 + parsedFee
                    : 0;

            return {
                price,
                source,
                estimatedTotal,
                guaranteeDeposit,
                canPrice: source !== "none",
                needsIlliquidityWarning: source === "lastDeal" || source === "close",
                rejectsIlliquidOrder: source === "none"
            };
        },
        getEstimatedTotalAsMoney(fee = 0) {
            let estimatedTotal = 0;
            if (this.orderType.toUpperCase().includes('ICEBERG')) {
                // no bonds allowed
                estimatedTotal = this.orderAction.toUpperCase().localeCompare('B') === 0 
                        ? parseFloat(this.limitOrderPrice || 0) * this.orderStockCount + parseFloat(fee)
                        : parseFloat(this.limitOrderPrice || 0) * this.orderStockCount - parseFloat(fee);
            } else if (this.orderType.toUpperCase().includes('STOP')) {
                if (this.getSelectedTradingCodeShareTypeId !== 2) {
                    // not a bond
                    estimatedTotal = this.orderAction.toUpperCase().localeCompare('B') === 0 
                        ? parseFloat(this.orderStopPrice || 0) * this.orderStockCount + parseFloat(fee)
                        : parseFloat(this.orderStopPrice || 0) * this.orderStockCount - parseFloat(fee);
                } else {
                    // bond
                    estimatedTotal = this.orderAction.toUpperCase().localeCompare('B') === 0
                        ? this.getBondEstimatedAmount(this.orderStopPrice || 0) + parseFloat(fee)
                        : this.getBondEstimatedAmount(this.orderStopPrice || 0) - parseFloat(fee);
                }
            } else if (this.orderType.toUpperCase().includes('MARKET')) {
                // market order
                estimatedTotal = this.getMarketOrderPricingDecision(fee).estimatedTotal;
            } else {
                // limit order
                if (this.getSelectedTradingCodeShareTypeId !== 2) {
                    // not a bond
                    estimatedTotal = this.orderAction.toUpperCase().localeCompare('B') === 0 
                        ? parseFloat(this.limitOrderPrice || 0) * this.orderStockCount + parseFloat(fee)
                        : parseFloat(this.limitOrderPrice || 0) * this.orderStockCount - parseFloat(fee);
                } else {
                    // bond
                    estimatedTotal = this.orderAction.toUpperCase().localeCompare('B') === 0
                        ? this.getBondEstimatedAmount(this.limitOrderPrice || 0) + parseFloat(fee)
                        : this.getBondEstimatedAmount(this.limitOrderPrice || 0) - parseFloat(fee);
                }
            }

            return Number(estimatedTotal.toFixed(2));
        },
        showMarketOrderWarning(message, canContinue) {
            const body = document.querySelector("body");
            this.marketOrderWarningMessage = message;
            this.marketOrderWarningCanContinue = canContinue;
            this.marketOrderWarningModalActive = true;
            this.marketOrderWarningModalShow = true;
            body.classList.add("modal-open");
        },
        closeMarketOrderWarningModal() {
            const body = document.querySelector("body");
            this.marketOrderWarningModalActive = false;
            this.marketOrderWarningModalShow = false;
            this.marketOrderWarningCanContinue = false;
            body.classList.remove("modal-open");
        },
        continueMarketOrderAfterWarning() {
            this.marketOrderWarningAcceptedKey = this.getMarketOrderPayloadKey();
            this.closeMarketOrderWarningModal();
            this.submitOrder();
        },
        validateMarketOrderBeforeSubmit() {
            if (!this.orderType.toUpperCase().includes('MARKET') || this.orderType.toUpperCase().includes('STOP')) {
                return false;
            }

            const pricingDecision = this.getMarketOrderPricingDecision();
            if (pricingDecision.rejectsIlliquidOrder) {
                this.showMarketOrderWarning(this.getMarketOrderIlliquidRejectMessage, false);
                return true;
            }

            const guaranteeDepositInPortfolioCurrency = UiUtils.getMoneyInCurrency(
                this.$store.getters["getWallet"],
                pricingDecision.guaranteeDeposit,
                this.getStockCurrency(false),
                this.getCurrency
            );
            if ("B" === this.orderAction && this.getAvailableToInvest < guaranteeDepositInPortfolioCurrency) {
                this.$toast.error(this.getInsufficientFundsMessage, {
                    "duration": 5000,
                    "pauseOnHover": true
                });
                this.$store.commit("addSystemMessage", {
                    date: (new Date()).getTime(),
                    mess: this.getInsufficientFundsMessage,
                    error: true
                });
                return true;
            }

            const payloadKey = this.getMarketOrderPayloadKey();
            if (pricingDecision.needsIlliquidityWarning && this.marketOrderWarningAcceptedKey !== payloadKey) {
                this.showMarketOrderWarning(this.getMarketOrderIlliquidContinueMessage, true);
                return true;
            }

            return false;
        },
        getOrderCommandType() {
            if (this.orderType.toUpperCase().includes('MARKET') 
                && this.orderType.toUpperCase().includes('STOP')) {
                return this.getStopMarketOption;
            }
            if (this.orderType.toUpperCase().includes('LIMIT') 
                && this.orderType.toUpperCase().includes('STOP')) {
                return this.getStopLimitOption;
            }
            if (this.orderType.toUpperCase().includes('MARKET')) {
                return this.getMarketOption;
            }
            if (this.orderType.toUpperCase().includes('ICEBERG')) {
                return this.getIcebergOption;
            }

            return this.getLimitOption;
        },
        formOrderObject(orderId, fee, time) {
            this.orderModel.action = 0 === this.orderAction.toUpperCase().localeCompare('B')
                ? this.getBuysLabel
                : this.getSellsLabel;
            this.orderModel.type = this.getOrderCommandType();
            this.orderModel.ex = this.getSelectedItemExchangeCode;
            this.orderModel.segment = this.getSelectedItemSegment;
            this.orderModel.stid = this.getSelectedTradingCodeShareTypeId;
            this.orderModel.cc = this.getStockCurrency(false);
            this.orderModel.code = this.getSelectedItemCode;
            this.orderModel.name = this.getStockName;
            this.orderModel.amount = this.orderStockCount;
            this.orderModel.validity = this.orderValidity;
            this.orderModel.restriction = this.orderRestriction;
            this.orderModel.expiry_date = this.getExpirationDateByOrderValidity();
            this.orderModel.oid = orderId;
            this.orderModel.fee = parseFloat(fee || 0);
            this.orderModel.time = this.getDate(time);
            this.orderModel.price = this.getEstimatedTotalAsMoney(fee);
            this.orderModel.stop = this.orderStopPrice;
            this.orderModel.peak = this.orderPeakValue;
            this.orderModel.tac = this.tradeAtClose;
        },
        async submitOrder() {
            const user = this.$store.getters["getUser"];
            let requestStarted = false;
            try {
                if (this.validateMarketOrderBeforeSubmit()) {
                    return;
                }
                // check iceberg params apriori
                if (this.orderType.toUpperCase().includes('ICEBERG')) {
                    // peak size at least 5%
                    if (this.orderPeakValue / this.orderStockCount < 0.05) {
                        // show error
                        this.$toast.error(this.getIcebergOrderPeakInvalidLabel, {
                                "duration": 5000,
                                "pauseOnHover": true
                            });
                            this.$store.commit("addSystemMessage", {
                                date: (new Date()).getTime(),
                                mess: this.getIcebergOrderPeakInvalidLabel,
                                error: true
                            });
                        return;
                    }
                    // order expected price must be 10000 EUR at least
                    const icebergExpectedPrice = this.getEstimatedTotalAsMoney();
                    const currency = this.getStockCurrency();
                    if (currency.toUpperCase().localeCompare("EUR")) {
                        if (icebergExpectedPrice < 10000) {
                            // show error
                            this.$toast.error(this.getIcebergOrderTotalAmountInvalidLabel, {
                                "duration": 5000,
                                "pauseOnHover": true
                            });
                            this.$store.commit("addSystemMessage", {
                                date: (new Date()).getTime(),
                                mess: this.getIcebergOrderTotalAmountInvalidLabel,
                                error: true
                            });
                            return;
                        }
                    } else {
                        if (icebergExpectedPrice < 19558.30) {
                            // show error
                            this.$toast.error(this.getIcebergOrderTotalAmountInvalidLabel, {
                                "duration": 5000,
                                "pauseOnHover": true
                            });
                            this.$store.commit("addSystemMessage", {
                                date: (new Date()).getTime(),
                                mess: this.getIcebergOrderTotalAmountInvalidLabel,
                                error: true
                            });
                            return;
                        }                        
                    }
                }
                this.$store.commit("setAppStateNotReady");
                requestStarted = true;
                const res = await http.getApiClient(this.getUserType()).get("", {
                    params: {
                        a: this.$store.getters["getOrderIdToUpdate"] !== ""
                            ? "update_order" 
                            : this.orderType,
                        id: user.id,
                        key: user.key,
                        action: this.orderAction,
                        code: UiUtils.combineExchangeStockPair(this.getSelectedItemExchangeCode, this.getSelectedItemCode),
                        amount: this.orderStockCount,
                        validity: this.orderValidity,
                        restr_code: this.orderRestriction === ""
                            ? null 
                            : this.orderRestriction,
                        price:  this.limitOrderPrice > 0
                            ? this.limitOrderPrice 
                            : null,
                        exp_date: this.getExpirationDateByOrderValidity(),
                        oid: this.$store.getters["getOrderIdToUpdate"] !== ""
                            ? this.$store.getters["getOrderIdToUpdate"] 
                            : null,
                        stop: this.orderStopPrice,
                        peak: this.orderPeakValue,
                        tac: this.tradeAtClose,
                    }
                });
                if (res) {
                    // check answer
                    if (ApiUtils.handleTraderNonRecoverableError(res, this.$store, this.$router, this.getUserLanguage)) {
                        this.$store.commit("setAppStateReady");
                        return;
                    }
                    if (ApiUtils.isApiResponseInvalidSession(res)) {
                        this.$store.commit("setAppStateReady");
                        // logout
                        setTimeout(
                            ApiUtils.cleanAndLogoutOnError(this.$store, this.$router, this.getInvalidSessionLabel, 1), 
                            500);
                        return;
                    } 
                    // get the error message if appropriate
                    const errorCode = HttpUtils.getStatusMessage(res.data.ec, this.getUserLanguage());
                    if (errorCode === "") { // ok
                        // show modal
                        this.formOrderObject(res.data.order_id, res.data.fee, res.data.ts);
                        this.orderPlacedModalActive = true;
                        this.orderPlacedModalShow = true;                        
                        this.$store.commit("setAppStateReady");
                        this.$toast.success(this.getOrderSentMessageLabel, {
                            "duration": 5000,
                            "pauseOnHover": true
                        });
                        this.$store.commit("addSystemMessage", {
                            date: (new Date()).getTime(),
                            mess: this.getOrderSentMessageLabel,
                            error: false
                        });
                        // remove previous order so user could not click multiple times and send the same order
                        this.orderStockCount = 0;
                        this.orderAction = "B";
                        this.orderMinExpectedPrice = 0;
                        this.orderMaxExpectedPrice = 0;
                        this.orderRestriction = "";
                        this.orderValidity = 1;
                        this.orderStopPrice = 0;
                        this.orderPeakValue = 0;
                        this.tradeAtClose = true;
                        /*this.$store.commit("setSelectedTradingCode", "");
                        this.$store.commit("setSelectedTradingExchangeId", 0);
                        this.$store.commit("setSelectedTradingStockName", "");
                        this.$store.commit("setSelectedTradingAction", "B");*/

                    } else {
                        this.$store.commit("setAppStateReady");
                        this.$toast.error(errorCode, {
                            "duration": 5000,
                            "pauseOnHover": true
                        });
                        this.$store.commit("addSystemMessage", {
                            date: (new Date()).getTime(),
                            mess: errorCode,
                            error: true
                        });
                    }
                }                
            } catch (err) {
                console.error(err);
            } finally {
                if (requestStarted) {
                    this.$store.commit("setAppStateReady");
                }
            }
            // remove the update order id
            this.$store.commit("setOrderIdToUpdate", "");
        },
        clearTradeForm() {
            // remove previous order so user could not click multiple times and send the same order
            this.orderStockCount = 0;
            this.orderAction = "B";
            this.orderMinExpectedPrice = 0;
            this.orderMaxExpectedPrice = 0;
            this.orderRestriction = "";
            this.orderValidity = 1;
            this.orderType = "put_market_order_ex";
            this.tradeAtClose = true;
            if (!this.preserveSelectedInstrument) {
                this.$store.commit("setSelectedTradingCode", "");
                this.$store.commit("setSelectedTradingExchangeId", 0);
                this.$store.commit("setSelectedTradingCodeSegment", "");
                this.$store.commit("setSelectedTradingStockName", "");
                this.$store.commit("setSelectedTradingAction", "B");
                this.$store.commit("setSelectedTradingCodeShareTypeId", 1);
            }
            this.$store.commit("setOrderIdToUpdate", "");
        },
        getUserLanguage() {
            return this.$store.getters["getNonLoggedInLanguage"]?.toUpperCase() || "EN";
        },
        parseNumber(num, afterDot = 2) {
            return UiUtils.formatNumber(num, afterDot);
        },
        onlyForCurrencyLimitedOrderPrice($event) {
            const keyCode = ($event.keyCode ? $event.keyCode : $event.which);

            // only allow number and one dot
            if ((keyCode < 48 || keyCode > 57) && (keyCode !== 46 || this.limitOrderPrice.toString().indexOf('.') != -1)) { // 46 is dot
                $event.preventDefault();
            }

            // restrict to 4 decimal places
            if (this.limitOrderPrice != null && this.limitOrderPrice.toString().indexOf(".") > -1 && (this.limitOrderPrice.toString().split('.')[1].length > 3)) {
                $event.preventDefault();
            }
        },
        onlyForCurrencyOrderStockCount($event) {
            const keyCode = ($event.keyCode ? $event.keyCode : $event.which);

            if (!this.orderStockCount && 48 === keyCode) {
                $event.preventDefault();
            }

            // only allow number
            if ((keyCode < 48 || keyCode > 57)) { // 46 is dot
                $event.preventDefault();
            }
        },        
        limitPriceFocusGained() {
            if (0 === this.limitOrderPrice) {
                this.limitOrderPrice = null;
            }
        },
        limitPriceFocusLost() {
            if (null === this.limitOrderPrice) {
                this.limitOrderPrice = 0;
            }
        },
        showSearchModal() {
            // open modal
            const body = document.querySelector("body");
            this.searchStockModalActive = true;
            this.searchStockModalShow = true;
            body.classList.add("modal-open");
            this.$nextTick(() => {
                document.getElementById("modalSearchBox")?.focus();
            });            
        },
        openTradeAtCloseInfoModal() {
            const body = document.querySelector("body");
            this.tradeAtCloseInfoModalActive = true;
            this.tradeAtCloseInfoModalShow = true;
            body.classList.add("modal-open");
        },
        closeTradeAtCloseInfoModal() {
            const body = document.querySelector("body");
            this.tradeAtCloseInfoModalActive = false;
            this.tradeAtCloseInfoModalShow = false;
            body.classList.remove("modal-open");
        },
        async getQuoteTr() {
            if ("" === this.getSelectedItemCode) {
                return;
            }
            // get quote trading for selected item
            const user = this.$store.getters["getUser"];
            // get exchange code
            const exchanges = this.$store.getters["getExchanges"];
            const itemExchangeCode = UiUtils.getExchangeCodeById(exchanges, this.$store.getters["getSelectedTradingExchangeId"]);
            try {
                const res = await http.getApiClient(this.getUserType()).get("", {
                    params: {
                        a: "get_quote_tr",
                        id: user.id,
                        key: user.key,
                        sc: UiUtils.combineExchangeStockPair(itemExchangeCode, this.getSelectedItemCode)
                    }
                });
                if (res) {
                    // check answer
                    if (ApiUtils.handleTraderNonRecoverableError(res, this.$store, this.$router, this.getUserLanguage)) {
                        this.$store.commit("setAppStateReady");
                        return;
                    }
                    if (ApiUtils.isApiResponseInvalidSession(res)) {
                        this.$store.commit("setAppStateReady");
                        // logout
                        setTimeout(ApiUtils.cleanAndLogoutOnError(this.$store, this.$router), 500);
                        return;
                    }
                    const errorCode = HttpUtils.getStatusMessage(res.data.ec, this.getUserLanguage());
                    if (errorCode === "") {
                        // set quote tr
                        this.quoteTrading = res.data;
                        this.$store.commit("setQuoteTrading", res.data);
                    } else {
                        this.$toast.error(errorCode, {
                            "duration": 5000,
                            "pauseOnHover": true
                        });
                        this.$store.commit("addSystemMessage", {
                            date: (new Date()).getTime(),
                            mess: errorCode,
                            error: true
                        });
                    }
                }
            } catch (err) {
                console.error(err);
            }
        },
        async getDepth() {
            if ("" === this.getSelectedItemCode) {
                return;
            }          
            const user = this.$store.getters["getUser"];
            // get exchange code
            const exchanges = this.$store.getters["getExchanges"];
            const itemExchangeCode = UiUtils.getExchangeCodeById(exchanges, this.$store.getters["getSelectedTradingExchangeId"]);
            try {
                let res = await http.getApiClient(this.getUserType()).get("", {
                    params: {
                        a: "get_depth",
                        id: user.id,
                        key: user.key,
                        sc: UiUtils.combineExchangeStockPair(itemExchangeCode, this.getSelectedItemCode)
                    }
                });
                if (res) {
                    // check answer
                    if (ApiUtils.handleTraderNonRecoverableError(res, this.$store, this.$router, this.getUserLanguage)) {
                        this.$store.commit("setAppStateReady");
                        return;
                    }
                    if (ApiUtils.isApiResponseInvalidSession(res)) {
                        this.$store.commit("setAppStateReady");
                        // logout
                        setTimeout(
                            ApiUtils.cleanAndLogoutOnError(this.$store, this.$router, this.getInvalidSessionLabel, 1),
                            500);
                        return;
                    }
                    const errorCode = HttpUtils.getStatusMessage(res.data.ec, this.getUserLanguage());                    
                    if (errorCode === "") {
                        // set in vuex
                        this.$store.commit("setDepth", res.data);
                    } else {
                        this.$toast.error(errorCode, {
                            "duration": 5000,
                            "pauseOnHover": true
                        });
                        this.$store.commit("addSystemMessage", {
                            date: (new Date()).getTime(),
                            mess: errorCode,
                            error: true
                        });
                    }
                }
                // set sse
                res = await http.getApiClient(this.getUserType()).get("", {
                    params: {
                        a: "set_sse",
                        id: user.id,
                        key: user.key,
                        "depth-set": UiUtils.combineExchangeStockPair(itemExchangeCode, this.getSelectedItemCode),
                        "depth-sts": "on"
                    }
                })
            } catch (err) {
                console.error(err);
            }
        },
        getStockCurrency(isSpecial = true) {
            if ("" === this.getSelectedItemCode) {
                return "";
            }

            const stocks = this.$store.getters["getStocks"];
            const matchingItems = stocks.filter(item => {
                return 0 === item.code.toString().toUpperCase().localeCompare(this.getSelectedItemCode.toUpperCase()) 
                    && item.cMIC === this.$store.getters["getSelectedTradingExchangeId"]
            });

            return isSpecial
                ? parseInt(matchingItems[0]?.stid ?? matchingItems[0]?.tID) == 2
                    ? '%'
                    : matchingItems[0]?.cc || ''
                : matchingItems[0]?.cc || '';
        }, 
        getSelectedTradingStock() {
            if ("" === this.getSelectedItemCode) {
                return null;
            }

            const stocks = this.$store.getters["getStocks"];
            const matchingItems = stocks.filter(item => {
                return 0 === item.code.toString().toUpperCase().localeCompare(this.getSelectedItemCode.toUpperCase()) 
                    && item.cMIC === this.$store.getters["getSelectedTradingExchangeId"]
            });

            return matchingItems?.[0] || null;
        }, 
    },
    computed: {
        getOrderToEdit() {
            return this.$store.getters["getOrderToEdit"];
        },
        getWindowsWidth() {
            return this.$store.getters["getAppWindowWidth"] || window.innerWidth;
        },        
        getStockName() {
            return this.$store.getters["getSelectedTradingStockName"];
        },        
        getCurrency() {
            return this.$store.getters["getCurrency"].toUpperCase();
        },
        portfolioSummary() {
            return getPortfolioSummary({
                wallet: this.$store.getters["getWallet"],
                stocks: this.$store.getters["getStocks"],
                indexedStocks: this.$store.getters["getIndexedStocks"],
                currency: this.getCurrency
            });
        },
        getAvailableToInvest() {
            return this.portfolioSummary.excessFunds;
        },
        isQuantityDecreaseDisabled() {
            return 0 === this.getStockName?.length
                || 0 >= parseFloat(this.orderStockCount || 0)
                || (0 === this.getAvailableStocks && "S" === this.orderAction);
        },
        isQuantityIncreaseDisabled() {
            const quantityStep = 2 !== this.getSelectedTradingCodeShareTypeId
                ? 1
                : this.getBondFaceValueStep();

            return 0 === this.getStockName?.length
                || ("S" === this.orderAction
                    && (0 === this.getAvailableStocks
                        || parseFloat(this.orderStockCount || 0) + quantityStep > this.getAvailableStocks));
        },
        canSubmitOrder() {
            if ("" === this.getSelectedItemCode || 0 >= parseFloat(this.orderStockCount || 0)) {
                return true;
            }

            if ("S" === this.orderAction && parseFloat(this.orderStockCount) > this.getAvailableStocks) {
                return true;
            }

            if (!this.isMarketOrder && 0 >= parseFloat(this.limitOrderPrice || 0)) {
                return true;
            }

            if (this.isStopOrder && 0 >= parseFloat(this.orderStopPrice || 0)) {
                return true;
            }

            if (this.isIcebergOrder && 0 >= parseFloat(this.orderPeakValue || 0)) {
                return true;
            }

            return false;
        },
        canClearTradeForm() {
            return Boolean(
                this.getSelectedItemCode
                || this.getSelectedItemSegment
                || 0 < parseFloat(this.orderStockCount || 0)
                || 0 < parseFloat(this.limitOrderPrice || 0)
                || 0 < parseFloat(this.orderStopPrice || 0)
                || 0 < parseFloat(this.orderPeakValue || 0)
                || this.orderAction !== "B"
                || this.orderType !== "put_market_order_ex"
                || parseInt(this.orderValidity) !== 1
                || this.orderRestriction
                || false === this.tradeAtClose
                || "" !== String(this.$store.getters["getOrderIdToUpdate"] || "")
            );
        },
        getShowIocValue() {
            if (this.getSelectedItemExchangeCode.toLowerCase().localeCompare('xfra') === 0) {
                return false;
            } 
            // by order validity
            else if (this.orderType.localeCompare("put_stop_market_order") === 0) {
                return false;
            } else if (this.orderType.localeCompare("put_stop_limit_order") === 0) {
                return false;
            } else if (this.orderType.localeCompare("put_iceberg_order") === 0) {
                return false;
            }  
            
            return true;
        },
        getShowBocValue() {
            if (this.getSelectedItemExchangeCode.toLowerCase().localeCompare('xfra') === 0) {
                return false;
            } 
            // by order validity
            else if (this.orderType.localeCompare("put_stop_market_order") === 0) {
                return false;
            } else if (this.orderType.localeCompare("put_stop_limit_order") === 0) {
                return false;
            } else if (this.orderType.localeCompare("put_market_order_ex") === 0) {
                return false;
            } else if (this.orderType.localeCompare("put_iceberg_order") === 0) {
                return false;
            } 
            
            return true;
        },
        getShowFokValue() {
            if (this.getSelectedItemExchangeCode.toLowerCase().localeCompare('xfra') === 0) {
                return false;
            } 
            // by order validity
            else if (this.orderType.localeCompare("put_stop_market_order") === 0) {
                return false;
            } else if (this.orderType.localeCompare("put_stop_limit_order") === 0) {
                return false;
            } else if (this.orderType.localeCompare("put_iceberg_order") === 0) {
                return false;
            } 
            
            return true;
        },
        getAvailableStocks() {
            return this.selectedPosition?.am || 0;
        },
        selectedPosition() {
            if ("" === this.getSelectedItemCode) {
                return null;
            }

            const wallet = this.$store.getters["getWallet"];
            if (!wallet || !wallet.s || !Array.isArray(wallet.s)) {
                return null;
            }

            const matchingItems = wallet.s.filter(item => {
                if (!item || typeof item.sc === "undefined") {
                    return false;
                }
                const codeMatches = 0 === item.sc.toString().toUpperCase().localeCompare(this.getSelectedItemCode.toUpperCase());
                const exchangeMatches = !item.ex || 0 === item.ex.toString().toUpperCase().localeCompare(this.getSelectedItemExchangeCode.toUpperCase());
                return codeMatches && exchangeMatches;
            });
            if (!matchingItems || 0 === matchingItems.length) {
                return null;
            }
            return matchingItems[0];
        },
        hasSelectedPosition() {
            return !!this.selectedPosition;
        },
        formatOwnedQuantity() {
            return this.parseNumber(this.getAvailableStocks, Number.isInteger(Number(this.getAvailableStocks)) ? 0 : 2);
        },
        formatAveragePositionPrice() {
            if (!this.selectedPosition) {
                return "";
            }
            return this.formatPrice(
                this.selectedPosition.ap,
                this.getStockCurrency(),
                UiUtils.calculateNumberOfMeaningfulDigits(this.selectedPosition.ap)
            );
        },
        isMarketOrder() {
            return this.orderType.toUpperCase().includes("MARKET");
        },
        isLimitOrder() {
            return this.orderType.toUpperCase().includes("LIMIT");
        },
        isStopOrder() {
            return this.orderType.toUpperCase().includes("STOP");
        },
        isIcebergOrder() {
            return this.orderType.toUpperCase().includes("ICEBERG");
        },
        getLimitOrderHintLabel() {
            if ("S" === this.orderAction && this.isStopOrder && this.isLimitOrder) {
                return this.t("stopLimitPriceSellOrderHintLabel");
            }

            return "B" === this.orderAction
                ? this.t("limitBuyOrderHintLabel")
                : this.t("limitSellOrderHintLabel");
        },
        getStopOrderHintLabel() {
            if (this.orderType.toUpperCase().includes("LIMIT")) {
                return "B" === this.orderAction
                    ? this.t("stopLimitBuyOrderHintLabel")
                    : this.t("stopLimitSellOrderHintLabel");
            }

            return "B" === this.orderAction
                ? this.t("stopMarketBuyOrderHintLabel")
                : this.t("stopMarketSellOrderHintLabel");
        },
        getIcebergPeakHintLabel() {
            return this.t("icebergPeakHintLabel");
        }, 
        getQuoteTrading() {
            const quoteTr = this.$store.getters["getQuoteTrading"];
            if (!quoteTr) {
                return { a: 0, b: 0, ltp: 0, clp: 0, minp: 0, maxp: 0, tick: 0 }
            }

            return quoteTr;
        },
        getStoredDepth() {
            const depth = this.$store.getters["getDepth"];
            return depth && depth.bcp ?
                depth :
                { bcp: 0, acp: 0, dif: 0, ch: 0, ldc: 0, ldp: 0, dv: 0, B: [], A: [] };
        },
        getBestPriceFromDepth() {
            const depth = this.getStoredDepth;
            let max;
            if ("S" === this.orderAction) {
                // get best buy price
                max = 0 !== depth.B.length 
                    ? depth.B.reduce((prev, current) => (prev && prev.p > current.p) ? prev : current)
                    : null;
            } else {
                // get best sell price
                max = 0 !== depth.A.length
                    ? depth.A.reduce((prev, current) => (prev && prev.p > current.p) ? prev : current)
                    : null;
            }

            return max?.p || 0;
        },
        getSelectedItemCode() {
            return this.$store.getters["getSelectedTradingCode"];
        },
        getSelectedItemSegment() {
            return this.$store.getters["getSelectedTradingCodeSegment"];
        },
        getSelectedTradingCodeShareTypeId() {
            return this.$store.getters["getSelectedTradingCodeShareTypeId"];
        },
        getSelectedItemExchangeCode() {
            const exchangeCode = this.$store.getters["getSelectedTradingExchangeId"];
            const exchanges = this.$store.getters["getExchanges"];
            return UiUtils.getExchangeCodeById(exchanges, exchangeCode);
        },
        getSelectedTradingAction() {
            return this.$store.getters["getSelectedTradingAction"];
        },
        getOrderSentMessageLabel() {            
            return this.t("orderSentMessage");
        },
        getOrderNotSentMessageLabel() {
            return this.t("orderNotSentMessage");
        },
        getInsufficientFundsMessage() {
            return this.t("insufficientFundsMessage");
        },
        getMarketOrderIlliquidContinueMessage() {
            return this.t("marketOrderIlliquidContinueMessage");
        },
        getMarketOrderIlliquidRejectMessage() {
            return this.t("marketOrderIlliquidRejectMessage");
        },
        getBuyLabel() {
            return this.t("buyLabel");
        },
        getSellLabel() {
            return this.t("sellLabel");
        },
        getBuysLabel() {
            return this.t("buysLabel");
        },
        getSellsLabel() {
            return this.t("sellsLabel");
        },
        getTypeLabel() {
            return this.t("typeLabel");
        },
        getOrderTypeLabel() {
            return this.t("tradingOrderTypeLabel");
        },
        getMarketOption() {
            return this.t("marketLabel");
        },
        getStopMarketOption() {
            return this.t("stopMarketLabel");
        },
        getLimitOption() {
            return this.t("limitLabel");
        },
        getStopLimitOption() {
            return this.t("stopLimitLabel");
        },
        getIcebergOption() {
            return this.t("icebergLabel");
        },
        getCodeLabel() {
            return this.t("codeLabel");
        },
        getNameLabel() {
            return this.t("nameLabel");
        },
        getCodePlaceholder() {
            return this.t("codePlaceholder");
        },
        getDynamicRangeLabel() {
            return this.t("dynamicRangeLabel");
        },
        getMinPriceLabel() {
            return this.t("minPriceLabel");
        },
        getMaxPriceLabel() {
            return this.t("maxPriceLabel");
        },
        getTickSizeLabel() {
            return this.t("tickSizeLabel");
        },
        getYouHaveLabel() {
            return this.t("youHaveLabel");
        },
        getYouOwnLabel() {
            return this.t("youOwnLabel");
        },
        getAveragePriceShortLabel() {
            return this.t("averagePriceShortLabel");
        },
        getMarketOrderHintLabel() {
            return this.t("marketOrderHintLabel");
        },
        getStocksLabel() {
            return this.t("stocksLabel");
        }, 
        getTotalEstimatedAmountLabel() {
            return this.t("totalEstimatedAmountLabel");
        },
        getEstimatedTotalLabel() {
            return this.t("estimatedTotalLabel");
        },
        getExcessFundsLabel() {
            return this.t("excessFundsLabel");
        },
        getPriceLabel() {
            return this.t("priceLabel");
        },
        getStopPriceLabel() {
            return this.t("stopPriceLabel");
        },
        getPeakLabel() {
            return this.t("peakLabel");
        },
        getTradeAtCloseLabel() {
            return this.t("tradeAtCloseLabel");
        },
        getTradeAtCloseInfoParagraphs() {
            return this.t("tradeAtCloseInfoParagraphs");
        },
        getChoseExpiryDateLabel() {
            return this.t("choseExpiryDateLabel");
        },
        getCloseLabel() {
            return this.t("closeLabel");
        },
        getCancelLabel() {
            return this.t("cancelLabel");
        },
        getContinueLabel() {
            return this.t("continueLabel");
        },
        getValidityLabel() {
            return this.t("validityLabel");
        },
        getDailyLabel() {
            return this.t("dailyLabel");
        },
        getDaysLabel() {
            return this.t("daysLabel");
        }, 
        getChoseDateLabel() {
            return this.t("choseDateLabel");
        },
        getGoodTillCancelledLabel() {
            return this.t("goodTillCancelledLabel");
        },
        getRestrictionsLabel() {
            return this.t("restrictionsLabel");
        },
        getNoRestrictionsLabel() {
            return this.t("noRestrictionsLabel");
        },
        getAcceptTCLabel() {
            return this.t("acceptTCLabel");
        },
        getSubmitLabel() {
            return this.t("submitLabel");
        },
        getClearLabel() {
            return this.t("clearLabel");
        },
        getSearchModalLabel() {
            return this.t("searchModalLabel");
        }, 
        getCouldNotReadQuotesMessage() {
            return this.t("couldNotReadQuotesMessage");
        },
        getNumberOfSharesLabel() {
            return this.t("numberOfSharesLabel");
        },
        getInvalidSessionLabel() {
            return this.t("invalidSessionLabel");
        },
        getCouldNotSetQuoteMessage() {
            return this.t("couldNotSetQuoteMessage");
        },
        getExchangeLabel() {
            return this.t("exchangeLabel");
        },
        getSegmentLabel() {
            return this.t("segmentLabel");
        },
        getFaceValueLabel() {
            return this.t("faceValueLabel");
        },
        getIcebergOrderPeakInvalidLabel() {
            return this.t("icebergOrderPeakInvalidLabel");
        },
        getIcebergOrderTotalAmountInvalidLabel() {
            return this.t("icebergOrderTotalAmountInvalidLabel");
        },
        calculateTickSize() {
            // algo from trader
            const quoteTr = this.$store.getters["getQuoteTrading"];
            if (!quoteTr) {
                return 0.0;
            }
            
            let orderSharePrice = quoteTr.a;
            let liqBandNumber = quoteTr.lbn;

            if (0 >= orderSharePrice) {
                orderSharePrice = quoteTr.ltp;
            }
            if (0 >= orderSharePrice) {
                orderSharePrice = quoteTr.clp;
            }
            if (64 === liqBandNumber && 1 === orderSharePrice) return 0.001;
            switch (liqBandNumber) {
                case 82: return 0.001;
                case 83: return 0.0001;
                case 84: return 0.001;
                case 85: return 0.001;
                case 86: return 0.001;
            }

            switch (liqBandNumber) {
                case 33: liqBandNumber = 1; break;
                case 34: liqBandNumber = 2; break;
                case 35: liqBandNumber = 3; break;
                case 37: liqBandNumber = 4; break;
                case 38: liqBandNumber = 5; break;
                case 39: liqBandNumber = 6; break;
                case 40: liqBandNumber = 7; break;
                case 41: liqBandNumber = 8; break;
                case 42: liqBandNumber = 9; break;
                case 43: liqBandNumber = 10; break;
                case 90: liqBandNumber = 2; break;
                case 91: liqBandNumber = 1; break;
            }
            if (0 >= liqBandNumber || 10 < liqBandNumber) return 0;

            let tickSize = sdMaxTickSizes[liqBandNumber];

            for (let i = 18; i > 0; i--) {
                if (orderSharePrice >= sdLiqPriceLevels[i]) {
                    break;
                }
                if (tickSize >= 500) tickSize = 200;
                else if (tickSize >= 200) tickSize = 100;
                else if (tickSize >= 100) tickSize = 50;
                else if (tickSize >= 50) tickSize = 20;
                else if (tickSize >= 20) tickSize = 10;
                else if (tickSize >= 10) tickSize = 5;
                else if (tickSize >= 5) tickSize = 2;
                else if (tickSize >= 2) tickSize = 1;
                else if (tickSize >= 1) tickSize = 0.5;
                else if (tickSize >= 0.5) tickSize = 0.2;
                else if (tickSize >= 0.2) tickSize = 0.1;
                else if (tickSize >= 0.1) tickSize = 0.05;
                else if (tickSize >= 0.05) tickSize = 0.02;
                else if (tickSize >= 0.02) tickSize = 0.01;
                else if (tickSize >= 0.01) tickSize = 0.005;
                else if (tickSize >= 0.005) tickSize = 0.002;
                else if (tickSize >= 0.002) tickSize = 0.001;
                else if (tickSize >= 0.001) tickSize = 0.0005;
                else if (tickSize >= 0.0005) tickSize = 0.0002;
                else if (tickSize >= 0.0002) tickSize = 0.0001;
            }
            return tickSize;
        }
    },
    async mounted() {
        await this.getQuoteTr();
    },
}
</script>

<style scoped>
    .trading-view {
        font-size: 1rem;
        line-height: 1.25;
    }

    .trading-view .mt15 {
        margin-top: 0.7rem;
    }

    .trading-view .mtb15 {
        margin-bottom: 0.65rem;
        margin-top: 0.65rem;
    }

    .trading-view label,
    .trading-view .form-select,
    .trading-view .form-control,
    .trading-view .input-group-text,
    .trading-view .btn,
    .trading-view table {
        font-size: 1rem;
    }

    .trading-view .form-control,
    .trading-view .form-select,
    .trading-view .input-group-text {
        min-height: 2rem;
        padding-bottom: 0.3rem;
        padding-top: 0.3rem;
    }

    .trading-view .btn {
        padding-bottom: 0.35rem;
        padding-top: 0.35rem;
    }

    .trading-view .trading-quantity-button {
        height: 2.5rem;
        padding: 0;
        width: 2.5rem;
    }

    .trading-view .table {
        margin-bottom: 0.45rem;
    }

    .trading-view .table > :not(caption) > * > * {
        padding-bottom: 0.25rem;
        padding-top: 0.25rem;
    }

    .trading-view .trading-dynamic-range-table {
        --bs-table-border-color: transparent;
    }

    .trading-view .trading-dynamic-range-label {
        font-size: 1rem;
        line-height: 1.35;
    }

    .trading-view .trading-dynamic-range-table th {
        font-size: 1rem;
        font-weight: normal;
        line-height: 1.35;
        padding-bottom: 0 !important;
    }

    .trading-view .trading-dynamic-range-table > :not(caption) > * > * {
        border-bottom: 0 !important;
        border-color: transparent !important;
    }

    .trading-view .trading-dynamic-range-table tbody td {
        font-size: 1rem;
        font-weight: 700;
        line-height: 1.35;
        padding-top: 0 !important;
    }

    .trading-view .trading-price-number-input {
        text-align: center;
    }

    .align-trade-buttons {
        margin-top: -0.8rem;
    }

    .align-trade-button-market {
        margin-top: 1.8rem;
    }

    .align-trade-button-limit {
        margin-top: 1.1rem;
    }

    .trading-order-hint {
        margin: 0.25rem 1.5rem 0;
        white-space: pre-line;
        width: calc(100% - 3rem);
    }

    .trading-owned-quantity-row {
        padding-top: 0.5rem;
    }

    .trading-helper-box {
        background-color: #f1f1f1;
        border-radius: 6px;
        color: #333;
        font-size: 1rem;
        line-height: 1.2;
        padding: 0.35rem 0.7rem;
        text-align: center;
    }

    .trading-view .trading-order-hint {
        padding-bottom: 0.15rem;
        padding-top: 0.15rem;
    }

    .trading-limit-order-hint {
        margin: 0.35rem auto 0.25rem;
    }

    .trading-extra-price-field {
        margin-top: 0.45rem;
    }

    .order-placed-modal-header {
        border-bottom: 0;
        justify-content: flex-end;
        padding-bottom: 0;
    }

    .trade-at-close-row {
        align-items: center;
        display: flex;
        gap: 0.25rem;
        margin-top: 0;
        padding-top: 0.5rem;
    }

    .trade-at-close-row label {
        line-height: 1.2;
        margin: 0;
        transform: translateY(1px);
    }

    .trade-at-close-checkbox {
        flex: 0 0 auto;
        margin: 0;
    }

    .trade-at-close-info-button {
        align-items: center;
        background-color: #fff;
        border: 1px solid #6c757d;
        border-radius: 50%;
        color: #00164b;
        display: inline-flex;
        font-size: 0.68rem;
        height: 1rem;
        justify-content: center;
        line-height: 1;
        margin: 0;
        padding: 0;
        transform: translateY(1px);
        width: 1rem;
    }

    .trade-at-close-info-body {
        font-size: 1rem;
        line-height: 1.35;
    }

    .trade-at-close-info-body p {
        margin-bottom: 0.85rem;
    }

    .trade-at-close-info-body p:last-child {
        margin-bottom: 0;
    }

    .market-order-warning-footer {
        gap: 0.5rem;
        justify-content: flex-end;
    }

    .market-order-warning-footer .btn {
        min-width: 5.5rem;
    }

    .trading-estimated-total-row {
        font-size: 1rem;
        line-height: 1.35;
        text-align: center;
    }

    .trading-available-invest-row {
        font-size: 1rem;
        line-height: 1.35;
        margin-top: 0.05rem;
        text-align: center;
    }

    .trading-actions-group {
        font-size: 1rem;
        line-height: 1.18;
    }

    .trading-actions-group .mt15 {
        margin-top: 0.45rem;
    }

    .trading-actions-group .align-trade-button-market,
    .trading-actions-group .align-trade-button-limit {
        margin-top: 0.65rem;
    }

    @media (min-width: 1200px) {
        .trading-view {
            min-height: calc(100vh - 8rem);
        }

        .trading-view > .row {
            min-height: inherit;
        }

        .trading-view > .row > .col-sm-12 {
            display: flex;
            flex-direction: column;
        }

        .trading-actions-group {
            margin-top: auto;
        }
    }

  .btn.btn-buy,
  .btn-check:checked + .btn.btn-buy {
    border: 2px solid #0088AA;
    border-radius: 5px;    
    background-color: #fff;
    color: #0088AA;
  }

  .btn.btn-sell,
  .btn-check:checked + .btn.btn-sell {
    border: 2px solid #ED6025;
    border-radius: 5px;    
    background-color: #fff;
    color: #ED6025;
  }
</style>
